module.exports = __webpack_public_path__ + "static/media/CTLI_3-315w.3673728c.webp";